import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-user",
  "use": "icon-user-usage",
  "viewBox": "0 0 300 300",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 300 300\" overflow=\"visible\" id=\"icon-user\">\r\n<g>\r\n\t<path d=\"M202.88,157.23c18.4-16.93,28.71-41.22,28.71-66.25c0-47.85-35.33-86.12-78.03-86.12c-43.43,0-78.03,38.28-78.03,86.12\r\n\t\tc0,22.82,8.1,44.17,22.82,61.1C99.82,153.55,149.88,199.93,202.88,157.23L202.88,157.23z M255.14,216.86l-42.69-39.75\r\n\t\tc-16.19,13.25-61.1,41.22-123.66-0.74c-19.14,14.72-69.19,57.42-63.31,85.39c0,0,0.74,29.44,53.74,30.92\r\n\t\tc0,0,158.26,11.78,184.76-16.19C264.71,277.22,293.42,258.08,255.14,216.86L255.14,216.86z M255.14,216.86\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/user.svg
// module id = EOg8
// module chunks = 34